import PropTypes from 'prop-types'
import Tooltip from '../../common/tooltip'
import { formatEmptyValue } from '../../../utils/common'
import { Edit, Trash } from '@styled-icons/boxicons-solid'

const InlineConnectionRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-1 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-4/12 items-center table_text">
          <Tooltip message={props?.from_id?.name}>
            <div>{formatEmptyValue(props?.from_id?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-4/12 pl-6 items-center table_text">
          <Tooltip message={props?.to_id?.name}>
            <div>{formatEmptyValue(props?.to_id?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text text-sm">
          <Tooltip message={`${props?.from_suffix}/${props.to_suffix}`}>
            <div>{props?.from_suffix}</div>
            <div>{props?.to_suffix}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text text-sm">
          <Tooltip message={`${props?.from_prefix}/${props.to_prefix}`}>
            <div>{props?.from_prefix}</div>
            <div>{props?.to_prefix}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center justify-end">
          <span
            onClick={() => {
              props.onShowDetails()
            }}
            className="cursor-pointer px-1"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
          <span
            onClick={() => {
              props.onDelete()
            }}
            className="cursor-pointer px-1"
          >
            <Trash size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

InlineConnectionRow.propTypes = {
  from_connector: PropTypes.object,
  id: PropTypes.number,
  to_connector: PropTypes.object,
  from_suffix: PropTypes.any,
  to_suffix: PropTypes.any,
  from_prefix: PropTypes.any,
  to_prefix: PropTypes.any,
  onShowDetails: PropTypes.func,
}

export default InlineConnectionRow
